import { render, staticRenderFns } from "./DashboardCommentsList.vue?vue&type=template&id=391c264c&"
import script from "./DashboardCommentsList.vue?vue&type=script&lang=js&"
export * from "./DashboardCommentsList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCommentsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports